import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

/**
 * Intercepts HTTP requests to add language headers.
 *
 * @param req The outgoing request object.
 * @param next The next interceptor in the chain.
 * @returns The request with the added language headers.
 */
export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const translateService = inject(TranslateService);
  const currentLang = translateService.currentLang || 'es';
  const clonedRequest = req.clone({
    setHeaders: {
      'x-custom-lang': currentLang,
      'Accept-Language': currentLang
    }
  });

  return next(clonedRequest);
};
